



























































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  FileUploadProcessingRule,
  FileUploadErrorProcessingRule
} from "@/employer/types";
import { useFileProcessorSettingsStore } from "@/shared/store/fileProcessorSettings";

@Component({
  components: {}
})

export default class FileUploadSettings extends Vue {
  @Prop() employerId: number;

  fileProcessorSettingsStore = useFileProcessorSettingsStore();

  FileUploadProcessingRule = FileUploadProcessingRule;
  FileUploadErrorProcessingRule = FileUploadErrorProcessingRule;

  selectedFileProcessingRule: FileUploadProcessingRule = FileUploadProcessingRule.override;
  selectedErrorRule: FileUploadErrorProcessingRule = FileUploadErrorProcessingRule.forceEntireSuccess;
  isSubmitting: false;

  mounted (): void {
    this.fileProcessorSettingsStore.getFileProcessorSettings(this.employerId);
  }

  @Watch("fileProcessorSettingsStore.fileUploadProcessingRule")
  @Watch("fileProcessorSettingsStore.fileUploadErrorProcessingRule")
  setFetchedSettings (): void {
    this.selectedFileProcessingRule = this.fileProcessorSettingsStore.fileUploadProcessingRule;
    this.selectedErrorRule = this.fileProcessorSettingsStore.fileUploadErrorProcessingRule;
  }

  onSubmit (): void {
    this.fileProcessorSettingsStore.saveFileProcessorSettings({
      fileProcessorRule: this.selectedFileProcessingRule,
      errorHandlingRule: this.selectedErrorRule,
      employerId: this.employerId
    });
  }
}

